"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGamblePlugin = void 0;
function isGamblePlugin(value) {
    return value.hasGamble !== undefined && value.startGamble !== undefined;
}
exports.isGamblePlugin = isGamblePlugin;
//# sourceMappingURL=GamblePlugin.js.map